import { render } from "./HandheldChart.vue?vue&type=template&id=83e538a8"
import script from "./HandheldChart.vue?vue&type=script&lang=js"
export * from "./HandheldChart.vue?vue&type=script&lang=js"
script.render = render

export default script